<ng-container *ngIf="true">
    <div class="bh-block">
        <h2 class="bh-block-title bh-block-title-left bh-block-title-lg">Choose your grade level</h2>
        <p class="bh-block-subtitle"></p>
        <div class="bh-grades">
            <ng-container *ngFor="let grade of interface.grades | sort:'asc':'order' | slice:0:9; let g=index">
                <a class="bh-grade" routerLink="/store/listing/{{grade.slug}}">{{grade.title}}</a>
            </ng-container>
        </div>
    </div>
</ng-container>

